import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Seo } from "../../components/site/Seo";
import { LogoMark } from "../../components/site/Logo";
import { useAuth } from "../../components/admin/Auth";
import { api, errorText } from "../../lib/api";

export default function AdminLogin() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const r = await api.post("/auth/login", { email, password });
      setUser(r.data);
      nav("/admin");
    } catch (e2) {
      setErr(errorText(e2));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="grid min-h-screen place-items-center bg-ag-ink px-5">
      <Seo title="Connexion admin | A+ Glass Haguenau" description="Espace d'administration" path="/admin/login" noindex />
      <form onSubmit={submit} className="w-full max-w-sm rounded-[1.75rem] bg-white p-8" data-testid="admin-login-form">
        <LogoMark className="h-12 w-12" />
        <h1 className="mt-5 font-display text-2xl font-extrabold text-ag-ink">Espace administration</h1>
        <div className="mt-6 space-y-3">
          <input className="field" type="email" placeholder="Email" required value={email} onChange={(e) => setEmail(e.target.value)} aria-label="Email" data-testid="admin-login-email" />
          <input className="field" type="password" placeholder="Mot de passe" required value={password} onChange={(e) => setPassword(e.target.value)} aria-label="Mot de passe" data-testid="admin-login-password" />
        </div>
        {err && <p className="mt-3 text-sm text-red-600" data-testid="admin-login-error">{err}</p>}
        <button disabled={busy} className="btn btn-blue mt-6 w-full justify-center" data-testid="admin-login-submit">{busy ? "Connexion…" : "Se connecter"}</button>
      </form>
    </div>
  );
}
